import request from '@/util/request'
export function lastLocation(imei){
    return request({
        url: '/track_record/last',
        method: 'post',
        data:{imei}
    })
}
